// @ts-nocheck
import getIconDataSrc from "@toolkit/Framework/Common/Utilities/getIconDataSrc";
import * as React from "react";

const Checkmark: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1.001 1.001 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33h-.01Z"
            />
        </svg>
    );
};

export const CheckmarkDataSrc = getIconDataSrc(Checkmark);

export default React.memo(Checkmark);
